import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import App from './App'
import { PostHogProvider } from 'posthog-js/react'
import { persistor, store } from 'featureSliced/shared/store'
import { PersistGate } from 'redux-persist/integration/react'
import { NavigationHandler } from 'featureSliced/shared/utils/navigate'

import { initSentry } from 'featureSliced/shared/utils/sentry'
import { initHtmlValidation } from 'featureSliced/shared/utils/htmlValidation'
import { postHogOptions } from 'featureSliced/shared/utils/postHog/options'

import 'featureSliced/shared/utils/localization/i18n'
import './index.css'

initSentry()
initHtmlValidation()

const isProd = process.env.REACT_APP_IS_PROD === '1'

const app = (
  <Router>
    <NavigationHandler />
    <App />
  </Router>
)

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {isProd ? (
        <PostHogProvider
          apiKey={process.env.REACT_APP_POSTHOG_KEY || ''}
          options={postHogOptions}
        >
          {app}
        </PostHogProvider>
      ) : (
        app
      )}
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)
